interface SubjectsToolbarButtonProps {
  onClick: () => void;
}

/**
 * Header toolbar button that opens the Edit Subject Areas dialog. Visually
 * mirrors the Refresh and Rooms buttons so the toolbar reads as a single row
 * of equivalent actions (matches prototype lines 367–368). The schedule home
 * page is responsible for gating this on the OrgAdmin+ role; the button itself
 * is presentation-only.
 */
export function SubjectsToolbarButton({ onClick }: SubjectsToolbarButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="schedule-subjects-button"
      aria-label="Edit subject area colors"
      className="bg-surface-2 text-text-soft rounded-md px-3 py-1.5 font-medium text-[13px] cursor-pointer flex items-center gap-1.5 hover:bg-surface-2/80"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        {/* Palette outline */}
        <path d="M12 3a9 9 0 1 0 0 18c1.5 0 2-1 2-2 0-1.5-1-1.5-1-3 0-1 1-2 2-2h2a4 4 0 0 0 4-4 9 9 0 0 0-9-7Z" />
        <circle cx="7.5" cy="10.5" r="1" fill="currentColor" />
        <circle cx="12" cy="7.5" r="1" fill="currentColor" />
        <circle cx="16.5" cy="10.5" r="1" fill="currentColor" />
      </svg>
      Subjects
    </button>
  );
}
